<template>
  <div>
    <v-card color="#EDF1F3">
      <v-layout align-center justify-start style="padding-left: 20px">
        <v-form ref="form"><img :src="imageFile ? imageUrl : api.GET_IMAGE(captain.profile_image)" class="image"
            :class="{ 'image-readonly': isDeleted }" @click="!isDeleted && $refs.image.click()" />
          <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />
        </v-form>

        <v-flex xs3>
          <div class="headline">
            {{ this.captain.first_name }} {{ this.captain.last_name }} (<span class="fa fa-star star"></span>
            <span class="star"> {{ this.captain.rating }} </span>) 
            
          </div>
          <div style="color: #8599a3">{{ this.captain.email }}</div>
          <div style="color: #8599a3; margin-top: 6px">
            {{ moment(this.captain.created_at).format(" DD MMM YYYY") }}
          </div>
        </v-flex>
        <v-flex  v-if="captain.deleted_at"  xs2>
          <span style="color: red; font-size: large;"> {{ $t("drivers.captainProfile.deletedAccount") }} </span>
        </v-flex>
        <v-flex xs2>
          <v-switch v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted" v-model="switch1" :label="$t('drivers.captainProfile.autonome')"
            @change="changeAutonomeMode" color="blue" :disabled="isDeleted"></v-switch>
        </v-flex>
        <v-flex xs2>
          <div v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted">
            <v-switch v-if="!vSwitchLoading" v-model="blackListed" :label="$t(blackListedTag)" @change="blockCaptain"
              color="red" :disabled="isDeleted"></v-switch>
          </div>
        </v-flex>
        <v-flex xs2>
          <div v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted">
            <v-switch v-if="!vSwitchLoading" v-model="dailyBlackListed" :label="$t(dailyblackListedTag)"
              @change="dailyBlockCaptain" color="red" :disabled="isDeleted"></v-switch>
          </div>
        </v-flex>
        <v-flex xs2>
          <v-btn v-if="isSuperAdmin && !isDeleted" @click="ejectFromStation" :loading="loading" style="float: right"
            color="primary">{{ $t("drivers.captainProfile.ejectFromStation") }}</v-btn>
        </v-flex>
        <v-flex xs2>
          <v-btn v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted" @click="addComplaint" :loading="loading"
            style="float: right" color="primary">{{ $t("drivers.captainProfile.fileComplaint") }}</v-btn>
        </v-flex>
         <v-flex xs2>
          <v-btn v-if="isSuperAdmin && !isDeleted" @click="deleteAccount" :loading="loading"
            style="float: right" color="primary">{{ $t("drivers.captainProfile.deleteAccount") }}</v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab :key="1" ripple active-class="tab"> {{ $t("drivers.captainProfile.driver") }} </v-tab>

      <v-tab-item>
        <v-card height="100%" style="height: 100%; position: absolute; width: 100%">
          <v-layout align-center>
            <v-flex xs6 style="height: 100%; margin-left: 100px">
              <v-card-title primary-title>
                <v-flex xs12 style="margin-bottom: 25px">
                  <div class="headline">{{ $t("drivers.captainProfile.information") }}</div>
                </v-flex>
                <v-flex xs12>
                  <table class="info-table">
                    <tr>
                      <td>{{ $t("drivers.captainProfile.firstName") }}</td>
                      <td v-if="this.$store.state.user.roles[0].name == 'Super Admin'">
                        <v-text-field v-model="editHolder.first_name_value"
                          style="float: left; width: calc(100% - 128px)" :label="$t('drivers.captainProfile.firstName')"
                          :disabled="isDeleted || !this.editHolder.first_name" :rules="[(val) => !!val || $t('drivers.captainProfile.required')]">
                        </v-text-field>
                        <div>
                          <button @click="editHolder.first_name = true" v-if="!this.editHolder.first_name && !isDeleted">
                            <v-icon>edit</v-icon>
                          </button>
                        </div>
                        <button @click="
                          editHolder.first_name = false;
                        editHolder.first_name_value =
                          captain.first_name;
                        " v-if="this.editHolder.first_name">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.first_name = false" v-if="this.editHolder.first_name">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                      <td v-else>
                        <b>{{ this.captain.first_name }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.lastName") }}</td>
                      <td v-if="this.$store.state.user.roles[0].name == 'Super Admin'">
                        <v-text-field v-model="editHolder.last_name_value"
                          style="float: left; width: calc(100% - 128px)" :label="$t('drivers.captainProfile.lastName')"
                          :disabled="isDeleted || !this.editHolder.last_name" :rules="[(val) => !!val || $t('drivers.captainProfile.required')]">
                        </v-text-field>
                        <div>
                          <button @click="editHolder.last_name = true" v-if="!this.editHolder.last_name && !isDeleted">
                            <v-icon>edit</v-icon>
                          </button>
                        </div>
                        <button @click="
                          editHolder.last_name = false;
                        editHolder.last_name_value =
                          captain.last_name;
                        " v-if="this.editHolder.last_name">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.last_name = false" v-if="this.editHolder.last_name">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                      <td v-else>
                        <b>{{ this.captain.last_name }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.phoneNumber") }}</td>
                      <td v-if="this.$store.state.user.roles[0].name != 'Goverment'">
                        <v-text-field v-model="editHolder.phone_number_value"
                          style="float: left; width: calc(100% - 128px)" :label="$t('drivers.captainProfile.phoneNumberLabel')"
                          :disabled="isDeleted || !this.editHolder.phone_number" :rules="[(val) => !!val || $t('drivers.captainProfile.required')]">
                        </v-text-field>
                        <div>
                          <button @click="editHolder.phone_number = true" v-if="!this.editHolder.phone_number && !isDeleted">
                            <v-icon>edit</v-icon>
                          </button>
                        </div>
                        <button @click="
                          editHolder.phone_number = false;
                        editHolder.phone_number_value =
                          captain.phone_number;
                        " v-if="this.editHolder.phone_number">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.phone_number = false" v-if="this.editHolder.phone_number">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                      <td v-else>
                        <b>{{ this.captain.phone_number }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.email") }}</td>
                      <td>
                        <b>{{ this.captain.email || $t("common.noData") }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.gender") }}</td>
                      <td>
                        <b v-if="this.captain.gender == true">{{ $t("drivers.captainProfile.female") }}</b><b v-if="this.captain.gender == false">{{ $t("drivers.captainProfile.male") }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.payment") }}</td>
                      <td>
                        <b>{{
                          this.captain.payment_method || $t("common.noData")
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.spokenLanguages") }}</td>
                      <td>
                        <b v-for="item in languages">{{ item + " " + " " }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.numberOfLicense") }}</td>
                      <td>
                        <b>{{
                          this.captain.username || $t("common.noData")
                        }}</b>
                      </td>
                    </tr>

                    <tr v-if="isSuperAdmin">
                      <td>Lemonway ID</td>
                      <td>
                        <v-text-field v-model="editHolder.lemonway_id_value"
                          style="float: left; width: calc(100% - 128px)" label="Lemonway ID"
                          :disabled="isDeleted || !this.editHolder.lemonway_id">
                        </v-text-field>
                        <button @click="editHolder.lemonway_id = true" v-if="!this.editHolder.lemonway_id && !isDeleted">
                          <v-icon>edit</v-icon>
                        </button>
                        <button @click="
                          editHolder.lemonway_id = false;
                        editHolder.lemonway_id_value =
                          captain.lemonway_card.lw_card_id;
                        " v-if="this.editHolder.lemonway_id">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.lemonway_id = false" v-if="this.editHolder.lemonway_id">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                    </tr>
                  </table>
                </v-flex>
              </v-card-title>
            </v-flex>
            <v-flex xs7 style="height: 100%">
              
            </v-flex>
          </v-layout>
          <v-btn v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted" @click="save" :loading="loading"
            style="float: right" color="primary">{{ $t("common.save") }}</v-btn>
        </v-card>
      </v-tab-item>
      <v-tab v-if="$store.state.user.roles[0].name != 'Call center'" active-class="tab" :key="2" ripple> {{ $t("drivers.captainProfile.rating") }} </v-tab>

      <v-tab-item v-if="$store.state.user.roles[0].name != 'Call center'">
        <Ratings />
      </v-tab-item>

      <v-tab v-if="$store.state.user.roles[0].name != 'Call center'" active-class="tab" :key="3" ripple> {{ $t("drivers.captainProfile.logs") }} </v-tab>

      <v-tab-item v-if="$store.state.user.roles[0].name != 'Call center'">
        <DataTable :url="api.ACTIONS.CHECK_LOGS" :enable-edit="false" :enable-add="false" :colors="carColors"
          :enable-delete="false" descending :formatter="formatters" :initial-url-search-params="logSearchParams"
          :fields-hidden-main="[
            'to_datetime'
          ]" :titles="logTitles" />
      </v-tab-item>

      <v-tab :key="4" ripple active-class="tab">{{ $t("drivers.captainProfile.car") }}</v-tab>

      <v-tab-item>
        <v-card style="height: 100%; width: 100%; position: absolute">
          <v-layout align-start>
            <v-flex xs12>
              <div class="captains-list">
                <div @click="changeCar(index)" class="captain" v-for="(car, index) in cars"
                  v-bind:class="{ active: active_el == index }"><span v-if="!car.deleted_at"
                    class="fa fa-star star"></span>
                  <div class="name">{{ $t("drivers.captainProfile.carN", { n: index + 1 }) }} </div>
                  <div v-if="car.brand" class="car">
                    {{ car.brand }},{{ " " + car.model }}
                  </div>
                </div>
                <div>
                  <v-btn color="primary" @click="goToAddCar()"
                    v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted">{{ $t("drivers.captainProfile.newCar") }}</v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs6 style="min-height: 100%; margin-left: 100px">
              <v-card-title primary-title>
                <v-flex xs12>
                  <table class="info-table">
                    <tr>
                      <td>{{ $t("drivers.captainProfile.vehicleType") }}</td>
                      <td>
                        <v-select v-model="editHolder.vehicle_type_value" style="float: left; width: calc(100% - 128px)"
                          :label="$t('drivers.captainProfile.vehicleType')" :items="vehicleTypes" item-value="id" item-text="name"
                          :disabled="isDeleted || !this.editHolder.vehicle_type" :rules="[(val) => !!val || $t('drivers.captainProfile.required')]">
                        </v-select>
                        <div v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted">
                          <button @click="editHolder.vehicle_type = true" v-if="!this.editHolder.vehicle_type">
                            <v-icon>edit</v-icon>
                          </button>
                        </div>
                        <button @click="
                          editHolder.vehicle_type = false;
                        editHolder.vehicle_type_value =
                          cars[car_index].vehicle_type;
                        " v-if="this.editHolder.vehicle_type">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.vehicle_type = false" v-if="this.editHolder.vehicle_type">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.brand") }}</td>
                      <td>
                        <v-select v-model="editHolder.car_brand_id_value" style="float: left; width: calc(100% - 128px)"
                          :label="$t('drivers.captainProfile.brand')" :items="carBrands" item-value="id" item-text="name"
                          :disabled="isDeleted || !this.editHolder.car_brand_id" :rules="[(val) => !!val || $t('drivers.captainProfile.required')]">
                        </v-select>
                        <div v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted">
                          <button @click="editHolder.car_brand_id = true" v-if="!this.editHolder.car_brand_id">
                            <v-icon>edit</v-icon>
                          </button>
                        </div>
                        <button @click="
                          editHolder.car_brand_id = false;
                        editHolder.car_brand_id_value =
                          cars[car_index].brand_id;
                        " v-if="this.editHolder.car_brand_id">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.car_brand_id = false" v-if="this.editHolder.car_brand_id">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.model") }}</td>
                      <td>
                        <v-select v-model="editHolder.car_model_value" style="float: left; width: calc(100% - 128px)"
                          :label="$t('drivers.captainProfile.model')" :items="carModels" item-value="id" item-text="name"
                          :disabled="isDeleted || !this.editHolder.car_model" :rules="[(val) => !!val || $t('drivers.captainProfile.required')]">
                        </v-select>
                        <div v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted">
                          <button @click="editHolder.car_model = true" v-if="!this.editHolder.car_model">
                            <v-icon>edit</v-icon>
                          </button>
                        </div>
                        <button @click="
                          editHolder.car_model = false;
                        editHolder.car_model_value =
                          cars[car_index].brand_model_id;
                        " v-if="this.editHolder.car_model">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.car_model = false" v-if="this.editHolder.car_model">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.color") }}</td>
                      <td>
                        <v-select v-model="editHolder.color_value" style="float: left; width: calc(100% - 128px)"
                          :label="$t('drivers.captainProfile.color')" :items="carColors" item-value="id" item-text="name"
                          :disabled="isDeleted || !this.editHolder.color" :rules="[(val) => !!val || $t('drivers.captainProfile.required')]">
                        </v-select>
                        <div v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted">
                          <button @click="editHolder.color = true" v-if="!this.editHolder.color">
                            <v-icon>edit</v-icon>
                          </button>
                        </div>
                        <button @click="
                          editHolder.color = false;
                        editHolder.color_value = cars[car_index].color;
                        " v-if="this.editHolder.color">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.color = false" v-if="this.editHolder.color">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.plateNumber") }}</td>
                      <td>
                        <v-text-field v-model="editHolder.plate_number_value"
                          style="float: left; width: calc(100% - 128px)" :label="$t('drivers.captainProfile.plateNumberLabel')"
                          :disabled="isDeleted || !this.editHolder.plate_number" :rules="[(val) => !!val || $t('drivers.captainProfile.required')]">
                        </v-text-field>
                        <div v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted">
                          <button @click="editHolder.plate_number = true" v-if="!this.editHolder.plate_number">
                            <v-icon>edit</v-icon>
                          </button>
                        </div>
                        <button @click="
                          editHolder.plate_number = false;
                        editHolder.plate_number_value = captain.first_name;
                        " v-if="this.editHolder.plate_number">
                          <v-icon>close</v-icon>
                        </button>
                        <button @click="editHolder.plate_number = false" v-if="this.editHolder.plate_number">
                          <v-icon>check</v-icon>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("drivers.captainProfile.manufactureYear") }}</td>
                      <td>
                        {{
                          this.cars[this.car_index].car_manufacture_year ||
                          $t("drivers.captainProfile.noDataAvailable")
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div v-for="(item, index) in car_constraints" :key="index">
                          <div>
                            <!-- {{ item.type }} -->
                            <v-switch color="red" class="constraints" v-model="car_constraints[index].status"
                              :label="`${item.constraint_name} : ${car_constraints[index].status}`" :false-value="0"
                              :true-value="1" :disabled="isDeleted || !hasPermission('UPDATE_PERSONAL_CONSTRAINS')
                                ">
                              <template v-slot:label>
                                <span :class="[item.strike_through ? 'strike_through' : '']">
                                  {{ car_constraints[index].constraint_name }}
                                </span>
                                <span> &nbsp;:&nbsp; {{ car_constraints[index].status == false ? $t('drivers.captainProfile.inactive') :
                                  $t('drivers.captainProfile.active') }}</span>
                              </template>
                            </v-switch>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <v-btn v-if="this.$store.state.user.roles[0].name != 'Goverment' && !isDeleted" @click="
                          saveCarInfo();
                        saveCarConstraints();
                        " color="primary" style="float: right">{{ $t("drivers.captainProfile.saveCarInfo") }}</v-btn>
                        <v-btn
                          v-if="hasPermission('DELETE_CAR') && !isDeleted && cars[car_index].deleted_at"
                          @click="deleteCar()" :loading="carDeleting" color="red" dark
                          style="float: right; margin-right: 10px">{{ $t("drivers.captainProfile.deleteCar") }}</v-btn>
                      </td>
                    </tr>
                  </table>
                </v-flex>
              </v-card-title>
            </v-flex>
            <v-flex xs6 style="height: 100%">
              <v-card-title primary-title>
                <v-flex style="margin-bottom: 15px">
                  <div>
                    {{ $t("drivers.captainProfile.statusLabel") }}
                    {{ !cars[car_index].deleted_at ? $t("drivers.captainProfile.carActive") : $t("drivers.captainProfile.carNotActive") }}
                  </div>
                </v-flex>
                <v-flex xs12 style="margin-bottom: 25px">
                  <div class="headline">{{ $t("drivers.captainProfile.documents") }}</div>
                </v-flex>
                <v-flex xs4>
                  <v-flex style="margin-bottom: 15px">
                    <div>{{ $t("drivers.captainProfile.assurance") }}</div>
                  </v-flex>
                 
                </v-flex>

                <v-flex xs4 v-if="hasPermission('VIEW_DOCUMENTS')">
                  <v-flex class="open" style="margin-bottom: 15px">
                    <b><a href="#" @click="openImage(car_docs[0])">{{ $t("drivers.captainProfile.open") }}</a></b></v-flex>
 
                </v-flex>
                <v-flex xs4>
                
                </v-flex>
              </v-card-title>
              <!-- <v-btn
                @click="saveCarConstraints"
                :loading="carLoading"
                style="float: right"
                color="primary"
                >Save Documents</v-btn
              > -->
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>

      <v-tab v-if="$store.state.user.roles[0].name != 'Call center'" :key="5" ripple active-class="tab">{{ $t("drivers.captainProfile.tripsStats") }}</v-tab>

      <v-tab-item v-if="$store.state.user.roles[0].name != 'Call center'">
        <v-card style="height: 100%; width: 100%; position: absolute">
          <MonthlyBookingsChart :captainId="$route.params.id" />
        </v-card>
      </v-tab-item>

      <v-tab v-if="$store.state.user.roles[0].name != 'Call center'" :key="6" ripple active-class="tab">{{ $t("drivers.captainProfile.statusCheckLogs") }}</v-tab>

      <v-tab-item v-if="$store.state.user.roles[0].name != 'Call center'">
        <v-card style="height: 100%; width: 100%">
          <TimelineComponent :dailyBasis="true" :captainId="$route.params.id" />
        </v-card>
      </v-tab-item>

      <v-tab :key="7" ripple active-class="tab">{{ $t("drivers.captainProfile.constraints") }}</v-tab>

      <v-tab-item>
        <v-card height="100%" style="height: 100%; position: absolute; width: 100%">
          <v-layout align-center>
            <v-flex xs6 style="height: 100%; margin-left: 100px">
              <v-card-title primary-title>
                <v-flex xs12 style="margin-bottom: 25px">
                  <div class="headline">{{ $t("drivers.captainProfile.driverConstraints") }}</div>
                </v-flex>
                <v-flex xs9 justify-space-around>
                  <v-flex v-for="(itemS, index) in captain_static_constraints" :key="'sttatic' + index">
                    <div>
                      <!-- {{ item.type }} -->
                      <v-switch color="red" class="constraints" v-model="itemS.status" :label="`${itemS.constraint_name} : ${itemS.status == false ? $t('drivers.captainProfile.inactive') : $t('drivers.captainProfile.active')
                        } `" :false-value="false" :true-value="true" :disabled="isDeleted || itemS.constraint_name == 'PEXT'
                          ? true
                          : !hasPermission('UPDATE_PERSONAL_CONSTRAINS')
                          ">

                      </v-switch>
                    </div>
                  </v-flex></v-flex>
                <v-flex xs9 justify-space-around>
                  <v-flex v-for="(item, index) in captain_constraints" :key="index">
                    <div>
                      <!-- {{ item.type }} -->
                      <v-switch color="red" class="constraints" v-model="captain_constraints[index].status" :label="`${item.constraint_name} : ${captain_constraints[index].status == 0
                        ? $t('drivers.captainProfile.inactive')
                        : $t('drivers.captainProfile.active')
                        } `" :false-value="0" :true-value="1" :disabled="isDeleted || item.constraint_name == 'PEXT'
                          ? true
                          : !hasPermission('UPDATE_PERSONAL_CONSTRAINS')
                          ">
                        <template v-slot:label>
                          <span :class="[item.strike_through ? 'strike_through' : '']">
                            {{ item.constraint_name }}
                          </span>
                          <span> &nbsp;:&nbsp; {{ item.status == false ? $t('drivers.captainProfile.inactive') : $t('drivers.captainProfile.active') }}</span>
                        </template>
                      </v-switch>
                    </div>
                  </v-flex></v-flex>
              </v-card-title>
            </v-flex>
          </v-layout>
          <v-btn v-if="!isDeleted" @click="saveDriverConstraints" :loading="uploading" style="float: right"
            color="primary">{{ $t("common.save") }}</v-btn>
          <v-dialog v-model="dialog" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                {{ $t("drivers.captainProfile.pleaseStandBy") }}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card>
      </v-tab-item>

      <v-tab :key="8" ripple active-class="tab">{{ $t("drivers.captainProfile.complaints") }}</v-tab>

      <v-tab-item>
        <CaptainComplaints :key="complaintsKey" :readonly="isDeleted" />
      </v-tab-item>

      <v-tab v-if="$store.state.user.roles[0].name != 'Call center'" :key="9" ripple active-class="tab">{{ $t("drivers.captainProfile.changeNameLogs") }}</v-tab>

      <v-tab-item v-if="$store.state.user.roles[0].name != 'Call center'"zx>
        <DataTable :url="api.ACTIONS.CAPTAIN_CHANGE_NAME_LOG(this.$route.params.id)" :enable-edit="false"
          :enable-add="false" :enable-delete="false" descending :formatter="formatters"
          :initial-url-search-params="logSearchParams" :disableSearch="true" :sortable="false"
          :titles="changeNameTitles" :fields-hidden-main="[
            'captain_id',
            'updated_at'
          ]" />

      </v-tab-item>

      <v-tab v-if="$store.state.user.roles[0].name != 'Call center'" :key="10" ripple active-class="tab"> {{ $t("drivers.captainProfile.shiftLogs") }}</v-tab>

      <v-tab-item v-if="$store.state.user.roles[0].name != 'Call center'">
        <v-card style="height: 100%; width: 100%; position: absolute">
          <ShiftLogs :captainId="$route.params.id" />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import LoadingComponent from "@/components/LoadingComponent";
import MonthlyBookingsChart from "@/components/profile/captain/MonthlyBookingsChart";
import Ratings from "@/components/profile/captain/Ratings";
import ShiftLogs from "@/components/profile/captain/ShiftLogs";
import TimelineComponent from "@/components/Timeline.vue";
import { number } from "yup/lib/locale";
import { toInteger } from "lodash";
import CaptainComplaints from "@/components/profile/captain/CaptainComplaints.vue";

export default {
  name: "CaptainProfile",
  title() {
    return this.$t("drivers.captainProfile.title");
  },
  components: {
    LoadingComponent,
    DataTable,
    MonthlyBookingsChart,
    Ratings,
    ShiftLogs,
    TimelineComponent,
    CaptainComplaints
  },

  data() {
    return {
      colors: {
        rating: {
          1: "red",
          2: "orange",
          3: "yellow",
          4: "green",
          5: "forestgreen",
        },
      },
      complaintsKey: 0,
      active: 0,
      switch1: false,
      vSwitchLoading: false,
      blackListed: false,
      dailyBlackListed: false,
      blackListedTag: "drivers.captainProfile.block",
      dailyblackListedTag: "drivers.captainProfile.blockDaily",
      carColors: [],

      log: "",
      active_el: 0,

      captain: "",
      captain_docs: "",
      car_docs: "",
      captain_cars: [],
      captain_constraints: [],
      captain_static_constraints: [],
      driver_constraints: [],
      car_constraints: [],
      cars: "",
      car_index: 0,
      imageName: "",
      imageUrl: "",
      imageFile: "",
      languages: [],
      data: [],
      loading: false,
      totalItems: 0,

      uploading: false,
      carLoading: false,
      carDeleting: false,
      dialog: false,
      selectedCarId: 0,
      editHolder: {
        vehicle_type: false,
        vehicle_type_value: 1,
        car_model: false,
        car_model_value: "",
        plate_number: false,
        plate_number_value: "",
        car_brand_id: false,
        car_brand_id_value: "",
        color: false,
        color_value: "",
        phone_number: false,
        phone_number_value: "",
        lemonway_id: false,
        lemonway_id_value: "",
        first_name: false,
        first_name_value: "",
        last_name: false,
        last_name_value: "",
      },
      carModels: [],
      vehicleTypes: [],
      carBrands: [],
      isSuperAdmin: false,
    };
  },
  created() {
    this.$store.state.user.roles.forEach((role) => {
      if (role.name === "Super Admin") {
        this.isSuperAdmin = true;
      } else {
        this.isSuperAdmin = false;
      }
    });

    this.loadCars();
  },
  mounted() {
    const tabFromQuery = this.$route.query.tab;
    if (tabFromQuery) {
      this.active = parseInt(tabFromQuery);
    }
    this.axios.get(`captain/${this.$route.params.id}`).then(({ data }) => {
      
        this.switch1 = data.data.autonome_mode;
        this.blackListed = data.data.blacklisted_at ? true : false;
        this.dailyBlackListed = data.data.dailyBlock || false;
        // console.log('this.blacklisted');
        // console.log(data.data.blacklisted_at);
        this.languages = [];
        this.captain = data.data;
        console.log("captain",this.captain)
        this.editHolder.first_name_value = data.data.first_name;
        this.editHolder.last_name_value = data.data.last_name;
        this.editHolder.phone_number_value = data.data.phone_number;
        this.editHolder.lemonway_id_value = data.data.lemonway_card.lw_card_id;
        // console.log(this.captain);
        for (let i = 0; i < data.data.languages.length; i++) {
          this.languages.push(data.data.languages[i].name);
        }
        // console.log(this.languages);

      
     
      this.loading = false;
    });

    this.axios.get(`check_log`).then(({ data }) => {
      this.log = data.data;
      // console.log(this.log);
    });

    this.axios
      .get(`document/captain/${this.$route.params.id}`)
      .then(({ data }) => {
        this.captain_docs = data.data;
        // console.log('captain docs');
        // console.log(this.captain_docs);
      });

    this.axios
      .post("getCaptainConstraints", {
        captain_id: this.$route.params.id,
      })
      .then(({ data }) => {
        data.data.static.forEach((rowS) => {
          this.captain_static_constraints.push(rowS);
        });
        data.data.dynamic.forEach((rowD) => {
          if (rowD.entity_type == "CAPTAIN") {
            this.captain_constraints.push(rowD);
          }
        });
      });

    // console.log("GETTING DATA");
    // this.getData();
  },
  watch: {
    blackListed(value) {
      this.blackListedTag = value ? "drivers.captainProfile.unblock" : "drivers.captainProfile.block";
    },
    dailyBlackListed(value) {
      this.dailyblackListedTag = value ? "drivers.captainProfile.unblockDaily" : "drivers.captainProfile.blockDaily";
    },

    selectedCarId: function (val) {
      this.axios.get(`document/car/` + val).then(({ data }) => {
        this.car_docs = data.data.filter(doc => doc.type === "Attestation d'assurance");
      });

      this.axios
        .post("getCarConstraints", {
          car_id: val,
        })
        .then(({ data }) => {
          this.car_constraints = data.data;
        });
    },

    "editHolder.car_brand_id_value": function (val) {
      this.axios
        .get(`car_brand/${val}/models?perPage=100`, {
          perPage: 100,
        })
        .then((models) => {
          this.carModels = models.data.data.data;
          this.editHolder.car_model_value =
            this.cars[this.car_index].brand_model_id;
        });
    },
  },
  methods: {
    ejectFromStation() {
      let captain_id = this.captain.id;
      this.loading = true;
      this.axios
        .post(`captain/${captain_id}/eject_from_station`)
        .then((res) => {
          this.loading = false;
          window.getApp.$emit("SHOW_TOAST", res.data.message, "green");
        })
        .catch((err) => {
          console.log("ejectFromStation err");
          console.log(err);
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.loading = false;
        });
    },
    goToAddCar() {
      if (this.cars.length >= 3)
        window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.maxCars"), "red");
      else this.$router.push(`/drivers/${this.$route.params.id}/createCar`);
    },
    changeAutonomeMode(value) {
      let status = toInteger(value);
      let captain_id = this.captain.id;
      this.axios
        .post(`captain/changeAutonomeModeSingle`, { status, captain_id })
        .then((res) => { })
        .catch((err) => {
          console.log("Autonomeerror");
        });
    },
    blockCaptain(value) {
      let prevValue = !value;
      let status = value ? "blacklist" : "un_blacklist";
      this.vSwitchLoading = true;
      console.log("captain Block");
      console.log(value);
      let captain_id = this.captain.id;
      this.axios
        .post(`captain/${captain_id}/${status}`)
        .then((res) => {
          this.vSwitchLoading = false;
          window.getApp.$emit("SHOW_TOAST", res.data.message, "green");
        })
        .catch((err) => {
          console.log("CaptainBlockError");
          console.log(prevValue);
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.blackListed = prevValue;
          this.vSwitchLoading = false;
        });
    },
    dailyBlockCaptain(value) {
      let prevValue = !value;
      let status = value ? "block_day" : "unblock_day";
      this.vSwitchLoading = true;
      console.log("daily captain Block");
      console.log(value);
      let captain_id = this.captain.id;
      this.axios
        .post(`captain/${captain_id}/${status}`)
        .then((res) => {

          this.vSwitchLoading = false;
          window.getApp.$emit("SHOW_TOAST", res.data.message, "green");
          if (value && res.data.data && res.data.data.blockNow != null)
            this.blackListed = res.data.data.blockNow;
          else if (!value)
            this.blackListed = false;
        })
        .catch((err) => {
          console.log("CaptainDailyBlockError");
          console.log(prevValue);
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.dailyBlackListed = prevValue;
          this.vSwitchLoading = false;
        });
    },
    ellipsify(str) {
      if (str.length > 10) {
        return str.substring(0, 10) + "...";
      } else {
        return str;
      }
    },
    expandTable(row) {
      row.expanded = !row.expanded;
    },
    showDetails(title, id) {
      this.axios.get(`complaint/${id}/audio`).then((res) => {
        this.$dialova({
          title: title,
          hideCancel: true,
          list: res.data.data,
          additionalData: {
            id: id,
          },
        })
          .then(() => { })
          .catch(() => { });
      });
    },

    saveDriverConstraints() {
      // this.editHolder
      this.uploading = true;
      this.dialog = true;

      this.axios
        .post("dynamic_constraints/editCaptainConstraint", {
          captainId: this.$route.params.id,
          static_cons: this.captain_static_constraints,
          dynamic_cons: this.captain_constraints,
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.constraintsSaved"), "green");
          // this.$router.push("/captains");
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.checkYourInfo"), "red");
          }
        })
        .then(() => {
          this.uploading = false;
          this.dialog = false;
        });
    },
    deleteAccount() {
      this.$dialova({
        title: this.$t("drivers.captainProfile.deletingAccount"),
        paragraph: this.$t("drivers.captainProfile.deleteAccountConfirm", { firstName: this.captain.first_name, lastName: this.captain.last_name }),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .delete(`captain/${this.captain.id}`)
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.deletedSuccessfully"), "green");
              close();
              this.$router.push("/captains");
            })
            .catch((err) => {
              let response = err.response;
              if (response) {
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              } else {
                window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.somethingWentWrong"), "red");
              }
              close();
            });
        })
        .catch(() => { });
    },
    addComplaint() {
      this.$dialova({
        title: this.$t("drivers.captainProfile.enterComplaintDescription"),
        input: [
          {
            placeholder: this.$t("drivers.captainProfile.bookingId"),
            value: "",
            key: "booking_id",
          },
          {
            placeholder: this.$t("drivers.captainProfile.description"),
            value: "",
            key: "description",
          },
        ],
        fileUpload: this.$t("drivers.captainProfile.soundFiles"),
        loader: true,
      }).then(({ value, close, files }) => {
        console.log(value);
        const params = new FormData();
        params.append("description", value.description);
        if (value.booking_id) params.append("booking_id", value.booking_id);
        if (files) {
          for (let i = 0; i < files.length; i++)
            params.append("wav_files[]", files[i]);
        }
        this.axios
          .post(`complaint/captain/${this.$route.params.id}/create`, params)
          .then(() => {
            //this.getData();
            this.complaintsKey++;
            window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.savedExcl"));
            close();
          })
          .catch((err) => {
            console.log("err");
            console.log(err.response.data.message);
            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
            close();
          });
        // .finally(() => getData());
      });
    },
    loadCars() {
      return this.axios
        .get(`captain/${this.$route.params.id}/cars`)
        .then(({ data }) => {
          this.cars = data.data;
          this.cars.map((item) => {
            item.vehicle_type = Number(item.vehicle_type);
            item.car_brand_id = Number(item.car_brand_id);
          });
          if (!this.cars.length) return;
          this.selectedCarId = this.cars[0].id;
          this.changeCar(0);
        });
    },
    deleteCar() {
      const car = this.cars[this.car_index];
      this.$dialova({
        title: this.$t("drivers.captainProfile.deletingCar"),
        paragraph: this.$t("drivers.captainProfile.deleteCarConfirm", { name: (car.brand ? car.brand + " " + car.model : this.$t("drivers.captainProfile.carN", { n: this.car_index + 1 })) + (car.number ? " (" + car.number + ")" : "") }),
        loader: true,
      })
        .then(({ close }) => {
          this.carDeleting = true;
          this.axios
            .delete(`car/${car.id}`)
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.deletedSuccessfully"), "green");
              close();
              return this.loadCars();
            })
            .catch((err) => {
              let response = err.response;
              if (response) {
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              } else {
                window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.somethingWentWrong"), "red");
              }
              close();
            })
            .then(() => {
              this.carDeleting = false;
            });
        })
        .catch(() => { });
    },
    saveCarInfo() {
      // const formData = new FormData();
      // formData.append('car[brand_model_id]', this.editHolder.car_model_value);
      // formData.append('car[car_brand_id]', this.editHolder.car_brand_id_value);
      // formData.append('car[number]', this.editHolder.plate_number_value);
      // formData.append('car[vehicle_type]', this.editHolder.vehicle_type_value);
      this.axios
        .put(`car/${this.selectedCarId}`, {
          brand_model_id: this.editHolder.car_model_value,
          car_Brand_id: this.editHolder.car_brand_id_value,
          number: this.editHolder.plate_number_value,
          vehicle_type: `${this.editHolder.vehicle_type_value}`,
          color_id: this.editHolder.color_value,
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.constraintsSaved"), "green");
          // changeCar(this.car_index);
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    saveCarConstraints() {
      this.uploading = true;
      this.dialog = true;

      this.axios
        .post(`dynamic_constraints/editCarConstraint`, {
          car_id: this.selectedCarId,
          array: this.car_constraints,
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.constraintsSaved"), "green");
          // this.$router.push("/captains");
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.checkYourInfo"), "red");
          }
        })
        .then(() => {
          this.uploading = false;
          this.dialog = false;
        });
    },
    changeCar(value) {
      this.car_index = value;
      this.active_el = value;
      this.car_docs = "";
      this.axios
        .get(`document/car/` + this.cars[this.car_index].id)
        .then(({ data }) => {
          this.car_docs = data.data.filter(doc => doc.type === "Attestation d'assurance");
           //console.log("car docs",this.car_docs);
        });
      this.axios.get(`car/` + this.cars[this.car_index].id).then(({ data }) => {
        this.car = data.data;
        this.selectedCarId = this.cars[this.car_index].id;
        this.editHolder.plate_number_value = this.cars[this.car_index].number;
        this.editHolder.car_brand_id_value = this.cars[this.car_index].brand_id;
        this.axios
          .get(`car_brand/${this.cars[this.car_index].brand_id}/models?perPage=100`, {
            perPage: 100,
          })
          .then((models) => {
            this.carModels = models.data.data.data;
            this.editHolder.car_model_value =
              this.cars[this.car_index].brand_model_id;
          });
        console.log("CAR", this.car_index + 1);
        console.log(this.cars[this.car_index]);
        this.editHolder.vehicle_type_value =
          this.cars[this.car_index].vehicle_type;
        this.axios
          .get("color", {
            perPage: 100,
          })
          .then(({ data }) => {
            this.editHolder.color_value =
              data.data[
                data.data.findIndex(
                  (cl) => cl.name == this.cars[this.car_index].color
                )
              ].id;
            this.carColors = data.data;
          });
      });

      this.axios.get("vehicle_type").then(({ data }) => {
        this.vehicleTypes = data.data.data;
        console.log(data);
      });

      this.axios
        .get("car_brand", {
          perPage: 100,
        })
        .then(({ data }) => {
          this.carBrands = data.data;
        });
      console.log("selectedCarId: " + this.selectedCarId);
    },
    openImage(value) {
       console.log("value__",value);

      window.open(this.api.GET_IMAGE(value.path), "_blank");
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        this.loading = false;
        const updatedData = [];
        if (this.imageFile)
          updatedData.push({ ["captain[profile_image]"]: this.imageFile });
        if (this.editHolder.phone_number_value)
          updatedData.push({
            "captain[phone_number]": this.editHolder.phone_number_value,
          });
        if (this.editHolder.first_name_value)
          updatedData.push({
            "captain[first_name]": this.editHolder.first_name_value,
          });
        if (this.editHolder.last_name_value)
          updatedData.push({
            "captain[last_name]": this.editHolder.last_name_value,
          });
        if (this.editHolder.lemonway_id_value)
          updatedData.push({
            "captain[lemonway_id]": this.editHolder.lemonway_id_value,
          });
        if (updatedData.length > 0) {
          this.loading = true;
          const formData = new FormData();
          formData.append("_method", "PUT");
          for (const field of updatedData) {
            const key = Object.keys(field)[0];
            formData.append(key, field[key]);
          }
          this.axios
            .post(this.api.ACTIONS.CAPTAINS + "/" + this.captain.id, formData)
            .then(({ data }) => {
              this.imageName = "";
              this.imageFile = "";
              this.imageUrl = "";
              this.captain = data.data;
              this.loading = false;
              window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.saved"));
            })
            .catch(({ response }) => {
              if (response && response.data && response.data.message)
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              else {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("drivers.captainProfile.somethingWentWrongExcl"),
                  "red"
                );
                console.log(data);
              }
              this.loading = false;
            });
        }
      } else {
        window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainProfile.checkAllFields"), "red");
      }
    },
    isValid() {
      console.log("isActive");
      return false;
    },
  },
  computed: {
    formatters() {
      const forEver = this.$t("drivers.captainProfile.forEver");
      return {
        notes: {
          author(value) {
            return `${value.first_name} ${value.last_name} (${value.username})`;
          },
          expiry_date(value) {
            if (!value) return forEver;
            return moment(value).format("DD-MM-YYYY  HH:mm");
          },
          created_at(value) {
            return moment(value).format("DD-MM-YYYY  HH:mm");
          },
        },
        logs: {
          created_at(value) {
            return moment(value).format("DD-MM-YYYY  HH:mm");
          },
        },
        from_datetime(value) {
          return moment(value).format("DD-MM-YYYY  HH:mm");
        },
        start_datetime(value) {
          return moment(value).format("DD-MM-YYYY  HH:mm");
        },
        created_at(value) {
          return !!value ? moment(value).format("DD-MM-YYYY  HH:mm") : '';
        }
      };
    },
    isDeleted() {
      return !!this.captain.deleted_at;
    },
    titles() {
      return {
        id: "#",
        start_datetime: this.$t("common.date"),
        pick_up_location_name: this.$t("drivers.captainProfile.pickUpLocation"),
        drop_off_location_name: this.$t("drivers.captainProfile.dropOffLocation"),
        passenger_name: this.$t("drivers.captainProfile.passenger"),
        meter_price: this.$t("drivers.captainProfile.price"),
        captain_rating: this.$t("drivers.captainProfile.rating"),
        from_datetime: this.$t("drivers.captainProfile.datetime"),
        status: this.$t("common.status"),
        station_id: this.$t("drivers.captainProfile.stationId"),
      };
    },
    logTitles() {
      return {
        id: this.$t("drivers.captainProfile.logId"),
        start_datetime: this.$t("common.date"),
        from_datetime: this.$t("drivers.captainProfile.datetime"),
        status: this.$t("common.status"),
        station_id: this.$t("drivers.captainProfile.stationId"),
        destination_area_name: this.$t("drivers.captainProfile.destination"),
      };
    },
    changeNameTitles() {
      return {
        id: this.$t("drivers.captainProfile.id"),
        first_name: this.$t("drivers.captainProfile.firstName"),
        last_name: this.$t("drivers.captainProfile.lastName"),
        created_at: this.$t("drivers.captainProfile.changeTime"),
      };
    },
    tripsTitles() {
      return {
        booking_id: this.$t("drivers.captainProfile.bookingId"),
        start_datetime: this.$t("common.date"),
        pick_up_location_name: this.$t("drivers.captainProfile.pickUpLocation"),
        drop_off_location_name: this.$t("drivers.captainProfile.dropOffLocation"),
        passenger_name: this.$t("drivers.captainProfile.clientName"),
        meter_price: this.$t("drivers.captainProfile.price"),
        captain_rating: this.$t("drivers.captainProfile.rating"),
        from_datetime: this.$t("drivers.captainProfile.datetime"),
      };
    },

    rideSearchParams() {
      const params = new URLSearchParams();
      params.append("captain_id", this.$route.params.id);
      params.append("filter", "ALL");
      return params;
    },
    logSearchParams() {
      const params = new URLSearchParams();
      params.append("captain_id", this.$route.params.id);
      params.append("descending", true);
      return params;
    },
    today() {
      return moment().format("YYYY-MM-DD");
    },
    
  },

  formatter() {
    return {
      // created_at(value) {
      //   return moment(value).format(" DD MMM YYYY");
      // },

      active(val) {
        //language=HTML
        return `
                      <i class="v-icon fa ${val ? "fa-check" : "fa-close"}"></i>
                      `;
      },
    };
  },
};
</script>

<style scoped>
.strike_through {
  text-decoration-line: line-through
}

.not-treated {
  td {
    background-color: rgba(220, 39, 39, 0.08);
    border-radius: 4px;
    color: rgb(220, 39, 39);
  }
}

.treated {
  td {
    background-color: rgba(99, 228, 24, 0.08);
    border-radius: 4px;
    color: rgb(5, 116, 51);
  }
}

.partially-treated {
  td {
    background-color: rgba(252, 179, 45, 0.08);
    border-radius: 4px;
    color: rgb(252, 179, 45);
  }
}

.body {
  background-color: #ffffff !important;
}

.docs:hover {
  cursor: pointer;
}

.star {
  color: #f3c220;
}

.image {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin-right: 17px;
  margin-top: 10px;
}

.image:hover {
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  cursor: pointer;
}

.image-readonly:hover {
  background-color: transparent;
  opacity: 1;
  cursor: default;
}

.tab {
  color: #e21024 !important;
}

.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

.captains-list {
  width: 100%;
  margin-left: 90px;
  z-index: 7;
  max-height: 100px;
  min-height: 100px;
  float: left;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.captain {
  width: max-content;
  float: left;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  cursor: pointer;

  img {
    height: 32px;
    width: 32px;
    float: left;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }
}

.car {
  color: #7e939c;
}

.open {
  margin-bottom: 15px;
  margin-left: 35px;
}

.constraints.v-label {
  font-size: xx-large !important;
}

.info-table {
  border-collapse: collapse;
  width: 100%;
}

.info-table td:not(:first-child) {
  padding: 12px;
}
</style>
